import React, { useEffect, useState } from "react";
import Icon from "../../../atoms/icon/Icon";
import InlineGroup from "../../../atoms/inlinegroup/InlineGroup";
import VerticalGroup from "../../../atoms/verticalgroup/VerticalGroup";
import RoundResultsContainer from "../components/RoundsResultsContainer";
import ResultsText from "../results-text/ResultsText";

interface Props {}

const RoundResultsThankYou: React.FC<Props> = () => {
  const [circlePos, setCirclePosition] = useState({ top: 420, left: 60 });
  const [ladyPos, setLadyPosition] = useState({ top: 0, left: 0 });
  const [textPos, setTextPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const updateSize = () => {
      let newLadyPos = { top: 380, left: -200 };
      let newCirclePos = { top: -20, left: 60 };
      let newTextPos = { top: 350, left: 260 };

      if (window.innerWidth > 2520) {
        newLadyPos = { top: 650, left: -300 };
        newCirclePos = { top: -100, left: 100 };
        newTextPos = { top: 650, left: 500 };
      } else if (window.innerWidth <= 1000) {
        newLadyPos = { top: 200, left: -55 };
        newCirclePos = { top: -50, left: 20 };
        newTextPos = { top: 210, left: 156 };
      } else if (window.innerWidth > 1000 && window.innerWidth < 1600) {
        newLadyPos = { top: 250, left: -130 };
        newCirclePos = { top: -50, left: 20 };
        newTextPos = { top: 260, left: 180 };
      }

      setLadyPosition(newLadyPos);
      setCirclePosition(newCirclePos);
      setTextPosition(newTextPos);
    };

    window.addEventListener("resize", updateSize);
    updateSize();

    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return (
    <RoundResultsContainer>
      <VerticalGroup full center wide verticalCenter>
        <InlineGroup
          center
          style={{
            position: "relative",
            top: circlePos.top,
            left: circlePos.left,
          }}
          className=""
        >
          <Icon
            type="thankyoucircle"
            dynamicSize={{ min: "450px", preferred: "40vw", max: "1500px" }}
            skipSizing
          />
          <VerticalGroup
            center
            verticalCenter
            style={{
              position: "absolute",
              top: textPos.top,
              left: textPos.left,
            }}
          >
            <ResultsText size="2xl" bold colour="blue">
              Thank You
            </ResultsText>
            <ResultsText size="xl" bold colour="blue">
              For Playing!
            </ResultsText>
          </VerticalGroup>
          <InlineGroup
            style={{
              position: "absolute",
              left: ladyPos.left,
              top: ladyPos.top,
            }}
          >
            <Icon
              type="ladythankyou"
              dynamicSize={{ min: "100px", preferred: "20vw", max: "1000px" }}
              skipSizing
            />
          </InlineGroup>
        </InlineGroup>
      </VerticalGroup>
    </RoundResultsContainer>
  );
};

export default RoundResultsThankYou;
